/**
 * `faq` — common wholesale questions (module 22 D3).
 *
 * A single-open accordion (Radix-backed @flint/ui primitive): keyboard-operable
 * (Enter/Space to toggle, arrows to move between questions), animated open/close
 * with a rotating chevron. Plain text answers (spec 42 R8).
 */
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../primitives/accordion.js";

export function Faq({
  heading,
  items,
}: {
  heading?: string | undefined;
  items: Array<{ question: string; answer: string }>;
}) {
  return (
    <section
      aria-label={heading ?? "Frequently asked questions"}
      style={{ maxWidth: "72ch", marginInline: "auto" }}
    >
      {heading ? (
        <h2
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 500,
            fontSize: "1.5rem",
            color: "var(--ink)",
            textAlign: "center",
            marginTop: 0,
            marginBottom: "1.25rem",
          }}
        >
          {heading}
        </h2>
      ) : null}
      <Accordion type="single" collapsible className="w-full">
        {items.map((it, i) => (
          <AccordionItem key={i} value={`faq-${i}`}>
            <AccordionTrigger className="gap-4 py-4 text-left text-[0.9375rem] font-semibold text-ink">
              {it.question}
            </AccordionTrigger>
            <AccordionContent className="whitespace-pre-wrap pb-4 text-[0.875rem] leading-relaxed text-ink-2">
              {it.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
